import { render } from "./App.vue?vue&type=template&id=1f5c6c58&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1f5c6c58&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1f5c6c58&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5c6c58"]])

export default __exports__